import { QuestionNode } from './question-node';

export class QuestionNodeDto {
  // æ ç­¾åè¡¨
  labelList: string[];
  // åäº«èèµæºåç§°
  resName?: string;
  // è¯é¢èç¹
  qusNode: QuestionNode;

  constructor() {
    this.labelList = [];
    this.qusNode = new QuestionNode();
  }
}
